import React, { createContext, useContext, useState, useCallback } from 'react';

export type DemoRole = 'loader' | 'technologist';

const STORAGE_KEY = 'demoRole';

interface RoleContextValue {
  role: DemoRole;
  setRole: (role: DemoRole) => void;
}

const RoleContext = createContext<RoleContextValue | null>(null);

export function RoleProvider({ children }: { children: React.ReactNode }) {
  const [role, setRoleState] = useState<DemoRole>(
    () => (localStorage.getItem(STORAGE_KEY) as DemoRole) || 'loader',
  );

  const setRole = useCallback((r: DemoRole) => {
    localStorage.setItem(STORAGE_KEY, r);
    setRoleState(r);
  }, []);

  return React.createElement(RoleContext.Provider, { value: { role, setRole } }, children);
}

export function useRole(): RoleContextValue {
  const ctx = useContext(RoleContext);
  if (!ctx) throw new Error('useRole must be used within RoleProvider');
  return ctx;
}
